

(function () {
  let isOpen = false;

  var initGorgiasChatPromise = (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { window.addEventListener('gorgias-widget-loaded', function () { resolve(); }) });

  if (window.chat_show_bubble) {
    let chatBubbleVisible = true;
    const hideChat = (shouldCloseChat = true) => {
      chatBubbleVisible = false;
      const chatButton = document.querySelector('#chat-button');
      if (chatButton) {
        chatButton.classList.add("chat-button-hide");
      }
      if (shouldCloseChat) {
        GorgiasChat.close();
      }
    };

    const showBubble = () => {
      chatBubbleVisible = true;
      const chatButton = document.querySelector('#chat-button');
      if (chatButton) {
        chatButton.classList.remove("chat-button-hide");
      }
    };

    document.addEventListener('drawerOrModalOpen.drawer-cart', hideChat);
    document.addEventListener('drawerOrModalOpen.drawer-menu', hideChat);
    document.addEventListener('drawerOrModalOpen.drawer-filter', hideChat);
    document.addEventListener('productBuyBar:onVisible', () => {
      if (window.innerWidth < 600) {
        hideChat(false);
      }
    });

    document.addEventListener('drawerOrModalClose.drawer-cart', showBubble);
    document.addEventListener('drawerOrModalClose.drawer-menu', showBubble);
    document.addEventListener('drawerOrModalClose.drawer-filter', showBubble);
    document.addEventListener('productBuyBar:onHidden', showBubble);

    initGorgiasChatPromise.then(() => {
      if (!chatBubbleVisible) {
        hideChat();
      }
    });
  }

  document.addEventListener('topMenuChatBubbleClick', () => {
    window.GorgiasChat.open()
  });
})();
